import { DatePipe } from '@angular/common';
import { EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddpartyComponent } from 'src/app/components/party/addparty/addparty.component';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addpurchasedetails',
  templateUrl: './addpurchasedetails.component.html',
  styleUrls: ['./addpurchasedetails.component.css']
})
export class AddpurchasedetailsComponent implements OnInit {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";


  purchaseBO: any = {}


  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  purchaseform = new FormGroup({
    purchasedetailsid: new FormControl(0),
    purchaseid: new FormControl(0),
    rawmaterialid: new FormControl(null, Validators.required),
    rawmaterialname: new FormControl(null),
    qty: new FormControl(null, Validators.required),
    unitprice: new FormControl(null, Validators.required),
    subtotal: new FormControl(null),
    uomid: new FormControl(null, Validators.required),
    taxid: new FormControl(null, Validators.required),
    taxname: new FormControl(null),
    taxrate: new FormControl(null),
    taxamt: new FormControl(null),
    cgsttaxrate: new FormControl(null),
    cgsttaxamt: new FormControl(null),
    sgsttaxrate: new FormControl(null),
    sgsttaxamt: new FormControl(null),
    igsttaxrate: new FormControl(null),
    igsttaxamt: new FormControl(null),
    taxable: new FormControl(null),
    nettotal: new FormControl(null),
    inactive: new FormControl(null),
  });


  formname: String = "Purchase";



  @Input() purchasedetailsid: number = 0
  @Input() purchaseid: number = 0

  @Input() purchasedetailsBO: any = {};

  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {

  }

  ngOnInit() {
    try {
      this.fnOnInitForm();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.purchaseform.reset();
      this.fnInitializeForm();

      this.fnGetRawmaterial();
      this.fnGetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }



  fnInitializeForm() {
    this.purchaseform.setValue({
      purchasedetailsid: this.purchasedetailsBO.purchasedetailsid,
      purchaseid: this.purchasedetailsBO.purchaseid,
      rawmaterialid: this.purchasedetailsBO.rawmaterialid,
      rawmaterialname: this.purchasedetailsBO.rawmaterialname,
      qty: this.purchasedetailsBO.qty,
      unitprice: this.purchasedetailsBO.unitprice,
      subtotal: this.purchasedetailsBO.subtotal,
      uomid: this.purchasedetailsBO.uomid,
      taxid: this.purchasedetailsBO.taxid,
      taxname: this.purchasedetailsBO.taxname,
      taxrate: this.purchasedetailsBO.taxrate,
      taxamt: this.purchasedetailsBO.taxamt,
      cgsttaxrate: this.purchasedetailsBO.cgsttaxrate,
      cgsttaxamt: this.purchasedetailsBO.cgsttaxamt,
      sgsttaxrate: this.purchasedetailsBO.sgsttaxrate,
      sgsttaxamt: this.purchasedetailsBO.sgsttaxamt,
      igsttaxrate: this.purchasedetailsBO.igsttaxrate,
      igsttaxamt: this.purchasedetailsBO.igsttaxamt,
      taxable: this.purchasedetailsBO.taxable,
      nettotal: this.purchasedetailsBO.nettotal,
      inactive: false,
    })
  }




  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var qty = this.purchaseform.get('qty').value;
    if (this.loginService.fnCheckZeroDetcimal(qty) === 0) {
      this.errtxt = "Quantity is cannot be empty"
      this.purchaseform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    // for (let row of this.purchasedetailscoll) {
    //   if (row.rawmaterialid > 0) {
    //     _detailscheck = true;
    //   }
    // }

    // if (!_detailscheck) {
    //   this.errtxt = "Purchase Details cannot be empty"
    //   this.purchaseform.controls['inactive'].setErrors({ 'notfound': true });
    //   _ischeck = true;
    // }
    // if (!_ischeck) {
    //   for (let row of this.purchasedetailscoll) {

    //     if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
    //       this.errtxt = "Quantity is cannot be empty"
    //       this.purchaseform.controls['inactive'].setErrors({ 'notfound': true });
    //       _ischeck = true;
    //     }

    //   }
    // }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.purchaseform.get('inactive')) {
      this.purchaseform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.purchaseform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          purchasedetailsid: this.purchaseform.get('purchasedetailsid').value,
          purchaseid: this.purchaseform.get('purchaseid').value,
          rawmaterialid: this.purchaseform.get('rawmaterialid').value,
          rawmaterialname: this.purchaseform.get('rawmaterialname').value,
          qty: this.purchaseform.get('qty').value,
          unitprice: this.purchaseform.get('unitprice').value,
          subtotal: this.purchaseform.get('subtotal').value,
          uomid: this.purchaseform.get('uomid').value,
          taxid: this.purchaseform.get('taxid').value,
          taxname: this.purchaseform.get('taxname').value,
          taxrate: this.purchaseform.get('taxrate').value,
          taxamt: this.purchaseform.get('taxamt').value,
          cgsttaxrate: this.purchaseform.get('cgsttaxrate').value,
          cgsttaxamt: this.purchaseform.get('cgsttaxamt').value,
          sgsttaxrate: this.purchaseform.get('sgsttaxrate').value,
          sgsttaxamt: this.purchaseform.get('sgsttaxamt').value,
          igsttaxrate: this.purchaseform.get('igsttaxrate').value,
          igsttaxamt: this.purchaseform.get('igsttaxamt').value,
          taxable: this.purchaseform.get('taxable').value,
          nettotal: this.purchaseform.get('nettotal').value,
        }

        var result = {
          'checkstatus': 'DONE',
          'data': data
        }

        this.emitData.emit(result);
        this.activeModal.close(true);



      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }




  //Close
  async fnCloseForm() {

    try {


      var result = {
        'checkstatus': 'CANCEL',
        'data': null
      }

      this.emitData.emit(result);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial() {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial()
        }, (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetTax() {
    this.isLoadingResult = true;

    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    var row = {
      purchasedetailsid: this.purchaseform.get('purchasedetailsid').value,
      purchaseid: this.purchaseform.get('purchaseid').value,
      rawmaterialid: this.purchaseform.get('rawmaterialid').value,
      rawmaterialname: this.purchaseform.get('rawmaterialname').value,
      qty: this.purchaseform.get('qty').value,
      unitprice: this.purchaseform.get('unitprice').value,
      subtotal: this.purchaseform.get('subtotal').value,
      uomid: this.purchaseform.get('uomid').value,
      taxid: this.purchaseform.get('taxid').value,
      taxname: this.purchaseform.get('taxname').value,
      taxrate: this.purchaseform.get('taxrate').value,
      taxamt: this.purchaseform.get('taxamt').value,
      cgsttaxrate: this.purchaseform.get('cgsttaxrate').value,
      cgsttaxamt: this.purchaseform.get('cgsttaxamt').value,
      sgsttaxrate: this.purchaseform.get('sgsttaxrate').value,
      sgsttaxamt: this.purchaseform.get('sgsttaxamt').value,
      igsttaxrate: this.purchaseform.get('igsttaxrate').value,
      igsttaxamt: this.purchaseform.get('igsttaxamt').value,
      taxable: this.purchaseform.get('taxable').value,
      nettotal: this.purchaseform.get('nettotal').value,
    }

    this.purchasedetailsBO.subtotal = row.qty * row.unitprice;

    this.purchaseform.patchValue({ 'subtotal': this.purchasedetailsBO.subtotal });
    //this.subtotal = this.subtotal + Number(row.subtotal)


    this.purchasedetailsBO.taxamt = Number(this.fnConvertDecimal(this.purchasedetailsBO.subtotal)) * Number(this.fnConvertDecimal(row.taxrate)) / 100
    this.purchaseform.patchValue({ 'taxamt': this.purchasedetailsBO.taxamt });

    //GST      
    this.purchasedetailsBO.cgsttaxamt = Number(this.fnConvertDecimal(this.purchasedetailsBO.taxamt)) / 2
    this.purchasedetailsBO.sgsttaxamt = Number(this.fnConvertDecimal(this.purchasedetailsBO.taxamt)) / 2
    this.purchasedetailsBO.igsttaxamt = 0

    this.purchaseform.patchValue({
      'cgsttaxamt': this.purchasedetailsBO.cgsttaxamt,
      'sgsttaxamt': this.purchasedetailsBO.sgsttaxamt,
      'igsttaxamt': this.purchasedetailsBO.igsttaxamt
    })

    this.purchasedetailsBO.taxable = Number(this.fnConvertDecimal(this.purchasedetailsBO.subtotal));
    this.purchaseform.patchValue({ 'taxable': this.purchasedetailsBO.taxable });

    this.purchasedetailsBO.nettotal = Number(this.fnConvertDecimal(this.purchasedetailsBO.taxable)) + Number(this.fnConvertDecimal(this.purchasedetailsBO.taxamt))
    this.purchaseform.patchValue({ 'nettotal': this.purchasedetailsBO.nettotal });
  }




  fnChangeRawmaterial() {

    var row = {
      rawmaterialid: this.purchaseform.get('rawmaterialid').value,
    }

    var _prodname = "", _uomid = null, _unitprice = 0, _taxid = null;

    for (let abo of this.rawmaterialColl) {
      if (row.rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;
        _uomid = abo.purchaseuomid;
        _taxid = abo.taxid;
      }
    }
    this.purchasedetailsBO.rawmaterialname = _prodname;
    this.purchasedetailsBO.unitprice = _unitprice;
    this.purchasedetailsBO.uomid = _uomid;
    this.purchasedetailsBO.taxid = _taxid;

    this.purchaseform.patchValue({ 'rawmaterialname': this.purchasedetailsBO.rawmaterialname });
    this.purchaseform.patchValue({ 'unitprice': this.purchasedetailsBO.unitprice });
    this.purchaseform.patchValue({ 'uomid': this.purchasedetailsBO.uomid });
    this.purchaseform.patchValue({ 'taxid': this.purchasedetailsBO.taxid });

    this.fnChangeTax()
  }


  fnChangeTax() {


    var row = {
      taxid: this.purchaseform.get('taxid').value,
    }



    var _taxname = "", _taxrate = 0;

    var _cgsttaxrate = 0, _sgsttaxrate = 0, _igsttaxrate = 0;

    for (let abo of this.taxColl) {
      if (row.taxid === abo.taxid) {
        _taxname = abo.taxname;
        _taxrate = abo.taxrate;
        _cgsttaxrate = abo.cgsttaxrate;
        _sgsttaxrate = abo.sgsttaxrate;
        _igsttaxrate = abo.igsttaxrate;
      }
    }
    this.purchasedetailsBO.taxname = _taxname;
    this.purchasedetailsBO.taxrate = _taxrate;
    this.purchasedetailsBO.cgsttaxrate = _cgsttaxrate;
    this.purchasedetailsBO.sgsttaxrate = _sgsttaxrate;
    this.purchasedetailsBO.igsttaxrate = _igsttaxrate;

    this.purchaseform.patchValue({ 'taxname': this.purchasedetailsBO.taxname });
    this.purchaseform.patchValue({ 'taxrate': this.purchasedetailsBO.taxrate });
    this.purchaseform.patchValue({ 'cgsttaxrate': this.purchasedetailsBO.cgsttaxrate });
    this.purchaseform.patchValue({ 'sgsttaxrate': this.purchasedetailsBO.sgsttaxrate });
    this.purchaseform.patchValue({ 'igsttaxrate': this.purchasedetailsBO.igsttaxrate });


    this.fnCalcDetails()

  }



  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.purchasedetailsBO.rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial();

    });
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
